import { render } from "./Details.vue?vue&type=template&id=ad577604&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Plots/Irrigations/Details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad577604"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad577604', __exports__)) {
    console.log('reload')
    api.reload('ad577604', __exports__)
  }
  
  module.hot.accept("./Details.vue?vue&type=template&id=ad577604&ts=true", () => {
    console.log('re-render')
    api.rerender('ad577604', render)
  })

}


export default __exports__